import { captureCheckoutEntry } from '@checkout/core'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { AppProviders } from './providers'

import './styles/global.css'

const rootElement = document.getElementById('root')
const checkoutEntry = captureCheckoutEntry()

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppProviders>
      <App checkoutEntry={checkoutEntry} />
    </AppProviders>
  </StrictMode>
)
